import React, { useContext, useEffect, useState } from "react";
import SharedLayoutContext from "./cui/components/layouts/sharedLayout/SharedLayout.context";
import { homeNavigationMenuData } from "./pages/home/Home.data";
import { atom, useRecoilState, useSetRecoilState } from "recoil";
import Cookies from "js-cookie";

import Home from "./pages/home/Home";
import {
  Authenticated,
  Anonymous,
  OidcIdentityContext,
} from "@rsmus/react-auth";
import { Header, userAction } from "@rsmus/rsm-catt-ui";
import { User } from "oidc-client-ts";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { CattThemeProvider, Theme } from "./cui/components/CattThemeProvider";
import SharedLayout from "./cui/components/layouts/sharedLayout/SharedLayout";
import { CreateFolders } from "./pages/CreateFolders/createFolders";
import CreateSitesAutomate from "./pages/CreateSites/CreateSite&SetUp";
import { AddClients } from "./pages/CreateSites/pages/Addclients";
import { Clients } from "./pages/CreateSites/pages/Clients";
import SitesWithLegalEntities from "./pages/CreateSites/SitesWithLegalEntities";
import IManageFilesContainer from "./pages/IManageFiles/IManageFilesContainer";
import PageNotFound from "./pages/pageNotFound/PageNotFound";
import { CashTaxDashboard } from "./pages/powerBI/CorporateSight/CashTaxDashboard";
import { CS_GlobalDirect } from "./pages/powerBI/CorporateSight/CS_GlobalDirect";
import { CS_USDirect } from "./pages/powerBI/CorporateSight/CS_USDirect";
import { EFilingTracker } from "./pages/powerBI/CorporateSight/E-Filing Tracker";
import { PBIPlanningIdeas } from "./pages/powerBI/CorporateSight/PBIPlanningIdeas";
import { ProjectTrackerFull } from "./pages/powerBI/CorporateSight/ProjectTrackerFull";
import { ProjectTrackerLite } from "./pages/powerBI/CorporateSight/ProjectTrackerLite";
import { PowerBIReportIM } from "./pages/powerBI/PowerBIReportIM";
import { PowerBISiteIM } from "./pages/powerBI/PowerBISiteIM";
import NewRollovers from "./pages/NewRollovers/NewRollovers";
import ProjectsView from "./pages/TIM-Projects/ProjectsView";
import { ScheduleFiles } from "./pages/scheduleFiles/ScheduleFiles";
import SiteAdminAccess from "./pages/SiteAdmin/SiteAdminAccess";
import { SiteMetrics } from "./pages/SiteMetrics/SiteMetrics";
import { SiteSettingsManager } from "./pages/SiteSettingsManager/SiteSettingsManager";
import { ThirdpartyOrganization } from "./pages/ThirdPartyOrganisation/ThirdPartyOrganisation";
import { UpdateMetadataLocationFiles } from "./pages/UpdateMetadataLocationFiles/UpdateMetadataLocationFiles";
import { UpdateSites } from "./pages/UpdateScreen/UpdateSiteInfo";
import { UpgradeSites } from "./pages/UpgradeSites/UpgradeSites";
import { ExternalApiClient } from "./ExternalApiClient/ExternalApiClient";
import { CentralControversyTracker } from "./pages/CentralControversyTracker/CentralControversyTracker";
import {
  AlertColor,
  snackbarState,
} from "./cui/commonComponents/CustomSnackbar";
import {
  FEATURES,
  permissionFlag,
  refreshFlagAtom,
  upgradeSitesResponseAtom,
} from "./constants";
import { SnackbarMessage } from "./hooks/useSnackbar.types";
import { applicationTitle } from "@rsmus/rsm-catt-ui";

import appLogo from "./cui/assets/serviceIcon/si_trade.svg";
import SignOut from "./pages/signOut/SignOut";
import { isEmpty, isNull } from "lodash";
import { envProperties } from "./util/EnvironmentProperties";
import { CreateHubConnection, StartHub } from "./signalr/signalr-connection";
import {
  CEMUserClients,
  CEMUserDetails,
  CEMUserRecord,
  PowerBIReport,
} from "./api-client-nswag/taxportal-client";
import { taxPortalClientApi, userAssignmentClientApi } from "./api-client-nswag/taxportal-client-runtime";
import { GlobalTaxInformation } from "./pages/powerBI/GlobalTaxInformation";
import { ControversyTracker } from "./pages/powerBI/ControversyTracker";
import { BulkSiteCreation } from "./pages/BulkSiteCreation/BulkSiteCreation";
import { UserAssignments } from "./pages/UserAssignments/UserAssignments";
import ManageCustomPermissions from "./pages/ManageCustomPermissions/ManageCustomPermissions";
import CustomPermissions from "./pages/CustomPermissions/CustomPermissions";
import AccessDenied from "./pages/pageNotFound/AccessDenied";
import { UserAssignmentListDto } from "./api-client-nswag/userassignment-client";
import { REACT_APP_SYSTEM_ADMIN_USERS } from "./envVariables";
import CustomPowerBISetup from "./pages/powerBI/CustomPowerBISetup/CustomPowerBISetup";
import CustomPowerBISiteReports from "./pages/powerBI/CustomPowerBISetup/CustomPowerBISiteReports";
import { CommonPowerBIPage } from "./pages/powerBI/CorporateSight/CommonPowerBIPage";
import FSTemplates from './pages/FSTemplates/FSTemplates';
import SiteProjectStatus from './pages/FSTemplates/SiteProjectStatus';
import SiteNotifications from './pages/SiteNotification/SiteNotifications';
import NexusChatLauncher from "./pages/NexusChat/NexusChatLauncher";
import { userCEMState } from "./recoil/userCEMState";
export { userCEMState } from "./recoil/userCEMState";

export const allPermissions = atom({
  key: "allPermissions",
  default: {
    CreateSites: false,
    CreateSitesAutomate: false,
    CreateTasks: false,
    Assignments: false,
    PowerBI: false,
    CSPowerBI: false,
    AssignUsers: false,
    CreateFolders: false,
    UpdateMetadataLocationFiles: false,
    ScheduleFiles: false,
    Rollovers: false,
    NewRollovers: false,
    IManageFiles: false,
    SiteSettingsManager: false,
    UpgradeSites: false,
    ThirdpartyOrganization: false,
    LeaderShip: false,
    CentralControversyTracker: false,
    ManageCustomPermissions: false,
    TIMProjects: false,
    UserAssignmentHistory: false,
    CustomPermissionReport: false,
    CustomPowerBISetup: false,
    FSTemplates: false,
  },
});
export const appPermission = atom<string[]>({
  key: "appPermission",
  default: [],
});
export const clientPermission = atom<string[]>({
  key: "clientPermission",
  default: [],
});
export const flagbool = atom<boolean>({
  key: "flagbool",
  default: false,
});

export const userPermissions = atom<string[]>({
  key: "userPermission",
  default: [],
});

export const flagUsageMetrics = atom<boolean>({
  key: "flagUsageMetrics",
  default: false,
});

export const externalClients = atom<CEMUserClients[]>({
  key: "externalClients",
  default: [],
});
export const CountryCode = atom<string | null | undefined>({
  key: "CountryCode",
  default: null,
});

export const userAssignmentsState = atom<UserAssignmentListDto[]>({
  key: "userAssignmentsState",
  default: [],
});

export const iFrameflagState = atom<boolean>({
  key: "iFrameflagState",
  default: false,
});

export const App: React.FunctionComponent = () => {
  var siteId = parseInt(sessionStorage.getItem("siteId")!);
  const { user, logout } = useContext(OidcIdentityContext);
  const setSnackbar = useSetRecoilState(snackbarState);
  const setRefreshFlag = useSetRecoilState(refreshFlagAtom);
  const [countryCode, setCountryCode] = useRecoilState(CountryCode);
  const [iframeFlag, setIframeFlag] = useRecoilState(iFrameflagState);
  const applicationTitle: applicationTitle = {
    app: "Tax Portal Automation Center",
    xp: "",
    appTag: "TP",
    appIco: "trending_up",
    appIcoVariant: "outlined",
    logo: appLogo,
    clientLogo: null,
  };
  const userActions: userAction[] = [
    {
      url: "https://dev-tpac.rsmus.com/home",
      text: "TPAC Dev",
    },
  ];
  const [flag, setflag] = useState(false);
  const urlIncludes = envProperties.reactAppHighQUrl;

  const { setNavigationMenuButtons } = useContext(SharedLayoutContext);
  const [permission, setPermission] = useRecoilState(allPermissions);
  const [appPermissions, setAppPermissions] = useRecoilState(appPermission);
  const [clientPermissions, setClientPermissions] =
    useRecoilState(clientPermission);
  const [flagPermision, setFlagPermision] = useRecoilState(flagbool);
  const [userInfo, setUserInfo] = useState({
    uuid: null,
    roles: [],
  });
  const [userCEM, setUserCEM] = useRecoilState(userCEMState);
  const [userAssignments, setUserAssignments] = useRecoilState(userAssignmentsState);
  const [clientData, setClientData] = useRecoilState(externalClients);
  const [usageMetricsFlag, setUsageMetricsFlag] =
    useRecoilState(flagUsageMetrics);

  const [userPermission, setUserPermission] = useRecoilState(userPermissions);
  const setUpgradeSitesResponse = useSetRecoilState(upgradeSitesResponseAtom);
  const [url, seturl] = useState("");

  const systemAdminUsers = React.useMemo<string[]>(() => {
    const raw = REACT_APP_SYSTEM_ADMIN_USERS;
    if (!raw) return [];

    return raw
      .split(",")
      .map((email: string) => email.replace(/"/g, "").trim().toLowerCase())
      .filter(Boolean);
  }, []);

  const isSystemAdmin = systemAdminUsers.includes(
    (user?.profile?.preferred_username ?? "").toLowerCase()
  )

  const handleSnackbar = (message: string, type: AlertColor) => {
    isJsonString(message)
      ? setUpgradeSitesResponse(message)
      : showSnackbar(message, type);
  };

  const hasAccess = (
    permissionFlag: boolean,
    requireAssignments = true,
    featureName = ""
  ): boolean => {
    if (isSystemAdmin) return true;

    if (!permissionFlag) return false;


    if (requireAssignments) {
      const hasAssignment = (userAssignments?.length ?? 0) > 0;
      if (!hasAssignment) return false;

      return hasFeatureInAssignments(
        userAssignments,
        featureName
      );
    }
    return true;
  };

  const hasFeatureInAssignments = (
    userAssignments: any[],
    featureName: string
  ): boolean => {
    if (!userAssignments?.length || !Array.isArray(userCEM?.client)) return false;
    return userAssignments.some((assignment) => {
      const client = userCEM.client.find(
        (c: any) => c.id === String(assignment.mdmClientId)
      );

      if (!client) return false;

      return client.features?.includes(featureName);
    });
  };

  const hasRoleBasedAccess = (
    permissionFlag: boolean,
    requireAssignments = true
  ): boolean => {
    if (isSystemAdmin) return true;

    // CustomPowerBI access is role-based; do not block on permissionFlag.
    const assignments = userAssignments ?? [];
    if (requireAssignments && assignments.length === 0) return false;

    const normalizeGroup = (value?: string | null) =>
      String(value ?? "").trim().toLowerCase();

    const getGroups = (a: UserAssignmentListDto): string[] =>
      String(a.userGroups ?? "")
        .split(",")
        .map((g) => g.trim())
        .filter(Boolean);

    const isSiteAdminGroup = (a: UserAssignmentListDto) =>
      getGroups(a).some((g) => normalizeGroup(g) === "site admin");

    const isContentAdminGroup = (a: UserAssignmentListDto) =>
      getGroups(a).some((g) => normalizeGroup(g) === "content admin");

    if (assignments.some(isSiteAdminGroup)) return true;

    return assignments.some(isContentAdminGroup);
  };

  const isJsonString = (message: string) => {
    try {
      JSON.parse(message);
      return true;
    } catch (e) {
      return false;
    }
  };

  const showSnackbar = (message: string, type: AlertColor) => {
    setSnackbar({
      open: true,
      message: message,
      severity: type,
    });
    if (message.includes("UsageMetrics")) {
      setUsageMetricsFlag(true);
    }
    setRefreshFlag((prevState: any) => !prevState);
  };
  const apiClient = new ExternalApiClient();

  useEffect(() => {
    setNavigationMenuButtons(homeNavigationMenuData);
  });

  useEffect(() => {
    if (window.self !== window.top) {
      setflag(true);
      setIframeFlag(true);
      // The app is opened in an iframe
      console.log("App is in an iframe.");
      //window.location.reload();
    } else {
      // The app is not in an iframe
      console.log("App is not in an iframe.");
    }
    if (user !== undefined && !user.expired) {
      if (isNaN(siteId)) siteId = 0;
      const hubConnection = CreateHubConnection(
        `${envProperties.ApiBackendUrl}/hubs/notifications`,
        siteId,
        user?.access_token as string
      );
      StartHub(hubConnection, handleSnackbar);
    }
  }, [user?.profile.rsmuid]);


  useEffect(() => {
    if (document.referrer) {
      const referrerUrl = new URL(document.referrer);
      const params = new URLSearchParams(referrerUrl.search);
      if (!params.has("metaData.siteID") && !params.has("code")) {
        sessionStorage.removeItem("siteId");
      }
    } else {
      const url = document.location.href ? document.location.href : "";
      const urlParams = new URL(url);
      const params = new URLSearchParams(urlParams.search);
      if (!params.has("siteID") && !params.has("code")) {
        sessionStorage.removeItem("siteId");
      }
    }

  }, [document.referrer, document.location.href]);

  useEffect(() => {
    if (!isNull(document.referrer) && !isEmpty(document.referrer)) {
      const splitUri = urlIncludes?.split("/");
      if (
        document.referrer.length > 0 &&
        splitUri?.length > 2 &&
        (document.referrer.includes(splitUri[2]) ||
          document.referrer.includes(splitUri[5]))
      ) {
        setflag(true);
        setIframeFlag(true);
      } else {
        setflag(false);
        setIframeFlag(false);
      }
      if (document.referrer?.split("siteID=")[1]?.split("&")[0] !== undefined) {
        var siteId = document.referrer?.split("siteID=")[1]?.split("&")[0];
        if (!isNull(siteId) && !isEmpty(siteId)) {
          sessionStorage.setItem("siteId", siteId);
        }
      }
      if (document.referrer?.split("homePageID=")[1] !== undefined) {
        var contentId = document.referrer?.split("homePageID=")[1];
        if (!isNull(contentId) && !isEmpty(contentId)) {
          sessionStorage.setItem("contentId", contentId);
        }
      }
    } else {
      const url = document.location.href ? document.location.href : "";
      if (url?.includes("siteID=")) {
        const urlParams = new URL(url);
        const params = new URLSearchParams(urlParams.search);
        sessionStorage.setItem("siteId", params.get("siteID")!);
      }
      if (url?.includes("homePageID=")) {
        const urlParams = new URL(url);
        const params = new URLSearchParams(urlParams.search);
        sessionStorage.setItem("contentId", params.get("homePageID")!);
      }
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user?.profile.rsmuid) {
          const [data, userAssignments] = await
            await Promise.all([
              apiClient.getCEMPermissions(),
              siteId
                ? userAssignmentClientApi.userAssignment_GetUserAssignmentList(
                  siteId,
                  user?.profile.preferred_username!,
                  null,
                  null
                )
                : Promise.resolve(null),
            ]);
          const sites: UserAssignmentListDto[] = userAssignments?.data?.data ?? [];
          const cemUserRecord = data ?? {};
          setUserAssignments(sites);
          setUserCEM(cemUserRecord);
          setFlagPermision(true);
          if (data !== null && data.application !== undefined) {
            const permissions = data.application.flatMap(
              (x: any) => x.permissions || [],
            );
            const features = data.application.flatMap(
              (x: any) => x.features || [],
            );
            const combined = [...permissions, ...features];
            setAppPermissions(Array.from(new Set(combined)));
          }
          if (data !== null && data.client !== undefined) {
            const permissions = data.client.flatMap(
              (x: any) => x.permissions || [],
            );
            const features = data.client.flatMap((x: any) => x.features || []);
            const combined = [...permissions, ...features];
            setClientPermissions(Array.from(new Set(combined)));
          }
          var combinedPermissions: any;
          var combinedRoles: any;
          if (data.application !== undefined) {
            combinedPermissions = new Set([
              ...data?.application?.flatMap(
                (app: any) => app.permissions || [],
              ),
              ...data?.application?.flatMap((app: any) => app.features || []),
            ]);
            combinedRoles = new Set([
              ...data?.application?.flatMap((app: any) => app.role || []),
            ]);
          }
          if (data.client !== undefined) {
            combinedPermissions = new Set([
              ...data?.client.flatMap((app: any) => app.permissions || []),
              ...data?.client.flatMap((app: any) => app.features || []),
            ]);
            combinedRoles = new Set([
              ...data?.client?.flatMap((app: any) => app.role || []),
            ]);
          }

          if (data.client !== undefined && data.application !== undefined) {
            combinedPermissions = new Set([
              ...data?.application?.flatMap(
                (app: any) => app.permissions || [],
              ),
              ...data?.application?.flatMap((app: any) => app.features || []),
              ...data?.client.flatMap((app: any) => app.permissions || []),
              ...data?.client.flatMap((app: any) => app.features || []),
            ]);
            combinedRoles = new Set([
              ...data?.application.flatMap((x: any) => x.role || []),
              ...data?.client.flatMap((x: any) => x.role || []),
            ]);
          }
          setUserInfo((e: any) => {
            return { ...e, roles: [...combinedRoles] };
          });

          setUserPermission(Array.from(combinedPermissions));
        }
      } catch (error) {
        console.log(error, "error");
        handleSnackbar(SnackbarMessage.ERROR, "error");
      }
    };
    fetchData();
  }, [user?.profile.rsmuid]);

  useEffect(() => {
    if (permissionFlag.permission === true) {
      if (userPermission.includes("CreateSites")) {
        setPermission((e: any) => {
          return { ...e, CreateSites: true };
        });
      }
      if (userPermission.includes("CreateSitesAutomate")) {
        setPermission((e: any) => {
          return { ...e, CreateSitesAutomate: true };
        });
      }
      if (userPermission.includes("CreateTasks")) {
        setPermission((e: any) => {
          return { ...e, CreateTasks: true };
        });
      }
      if (userPermission.includes("Assignments")) {
        setPermission((e: any) => {
          return { ...e, Assignments: true };
        });
      }
      if (
        clientPermissions.includes("PowerBI") ||
        userPermission.includes("PowerBI")
      ) {
        setPermission((e: any) => {
          return { ...e, PowerBI: true };
        });
      }
      if (userPermission.includes("CreateFolders")) {
        setPermission((e: any) => {
          return { ...e, CreateFolders: true };
        });
      }
      if (userPermission.includes("AssignUsers")) {
        setPermission((e: any) => {
          return { ...e, AssignUsers: true };
        });
      }
      if (userPermission.includes("UpdateMetadataLocationFiles")) {
        setPermission((e: any) => {
          return { ...e, UpdateMetadataLocationFiles: true };
        });
      }
      if (userPermission.includes("ScheduleFiles")) {
        setPermission((e: any) => {
          return { ...e, ScheduleFiles: true };
        });
      }
      if (userPermission.includes("Rollovers")) {
        setPermission((e: any) => {
          return { ...e, Rollovers: true };
        });
      }
      if (userPermission.includes("NewRollovers")) {
        setPermission((e: any) => {
          return { ...e, NewRollovers: true };
        });
      }
      if (userPermission.includes("SiteSettingsManager")) {
        setPermission((e: any) => {
          return { ...e, SiteSettingsManager: true };
        });
      }
      if (
        userPermission.includes("CS PowerBI") ||
        clientPermissions.includes("CS PowerBI")
      ) {
        setPermission((e: any) => {
          return { ...e, CSPowerBI: true };
        });
      }
      if (userPermission.includes("UpgradeSites")) {
        setPermission((e: any) => {
          return { ...e, UpgradeSites: true };
        });
      }
      if (userPermission.includes("ThirdpartyOrganization")) {
        setPermission((e: any) => {
          return { ...e, ThirdpartyOrganization: true };
        });
      }
      if (userPermission.includes("LeaderShip")) {
        setPermission((e: any) => {
          return { ...e, LeaderShip: true };
        });
      }
      if (userPermission.includes("CentralControversyTracker")) {
        setPermission((e: any) => {
          return { ...e, CentralControversyTracker: true };
        });
      }
      if (userPermission.includes("IManageFiles")) {
        setPermission((e: any) => {
          return { ...e, IManageFiles: true };
        });
      }
      if (userPermission.includes("TIMProjects")) {
        setPermission((e: any) => {
          return { ...e, TIMProjects: true };
        });
      }
      if (userPermission.includes("ManageCustomPermissions")) {
        setPermission((e: any) => {
          return { ...e, ManageCustomPermissions: true };
        });
      }
      if (userPermission.includes("CustomPermissionReport")) {
        setPermission((e: any) => {
          return { ...e, CustomPermissionReport: true };
        });
      }
      if (userPermission.includes("UserAssignmentHistory")) {
        setPermission((e: any) => {
          return { ...e, UserAssignmentHistory: true };
        });
      }
      if (userPermission.includes("FSTemplates")) {
        setPermission((e: any) => {
          return { ...e, FSTemplates: true };
        });
      }
    } else {
      setPermission({
        CreateSites: true,
        CreateSitesAutomate: true,
        CreateTasks: true,
        Assignments: true,
        PowerBI: true,
        CSPowerBI: true,
        CreateFolders: true,
        AssignUsers: true,
        UpdateMetadataLocationFiles: true,
        ScheduleFiles: true,
        Rollovers: true,
        NewRollovers: true,
        IManageFiles: true,
        SiteSettingsManager: true,
        UpgradeSites: true,
        ThirdpartyOrganization: true,
        LeaderShip: true,
        CentralControversyTracker: true,
        ManageCustomPermissions: true,
        TIMProjects: true,
        UserAssignmentHistory: true,
        CustomPermissionReport: true,
        CustomPowerBISetup: true,
        FSTemplates: true,
      });
    }
  }, [userPermission, clientPermissions]);

  useEffect(() => {
    const stringUserInfo = JSON.stringify(userInfo);
    Cookies.set("OBUSIN", stringUserInfo, { sameSite: "None", secure: true });
    const deleteCookie = () => {
      Cookies.remove("OBUSIN", { path: "/", sameSite: "None", secure: true });
    };
    window.addEventListener("beforeunload", deleteCookie);
    return () => {
      window.removeEventListener("beforeunload", deleteCookie);
      deleteCookie();
    };
  }, [userInfo.roles, userInfo.uuid]);

  // const taskTemplateSelector = selector({
  // 	key:'charValueSelector',
  // 	get:({get})=>{
  // 	  const text = get(taskTemplateData);
  // 	  return text
  // 	}
  //   })

    const iframeContent = `
  <p>
    <script type="text/javascript">
      (function() {
        var walkme = document.createElement('script');
        walkme.type = 'text/javascript';
        walkme.async = true;
        walkme.src = 'https://cdn.walkme.com/users/323277ea8a76498da728d2978cd1e2c6/test/walkme_323277ea8a76498da728d2978cd1e2c6_https.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(walkme, s);
        window._walkmeConfig = { smartLoad: true };
      })();
    </script>
  </p>
`;
  useEffect(() => {
    const checkTokenExpiry = () => {
      const currentTime = Math.floor(Date.now() / 1000);

      if (user?.expires_at !== undefined) {
        if (currentTime >= user?.expires_at) {
          console.log("CheckTokenExpiry Navigating to SignOut.");
          console.log(`${window.location.origin}/signout`);
          window.location.href = `${window.location.origin}/signout`;
        }
      }
    };
    checkTokenExpiry();
    const intervalId = setInterval(checkTokenExpiry, 60000);
    return () => clearInterval(intervalId);
  }, [user?.expires_at]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user?.profile.rsmuid) {
          const userDetails: CEMUserDetails = {
            userId: user?.profile.rsmuid as string,
            userName: user?.profile.preferred_username as string,
          };
          const filterData: CEMUserRecord =
            await taxPortalClientApi.cEM_UpdateSitesForUser(userDetails);
          setUserInfo((e: any) => {
            return { ...e, uuid: filterData.tpuuid };
          });
          setCountryCode(filterData.countryCode);
          if (filterData.cemUserClients !== undefined) {
            setClientData(filterData.cemUserClients);
          }
        }
      } catch (error) {
        console.log(error, "UpdateSitesForUser Navigating to SignOut, Error");
        //window.location.href = `${window.location.origin}/signout`;
        handleSnackbar(SnackbarMessage.ERROR, "error");
      }
    };
    fetchData();
  }, [user?.profile.rsmuid]);

  const canAccessCustomPowerBISetup = (): boolean => {
    const hasReportParam = !!new URLSearchParams(window.location.search).get("PowerBIReport");
    return hasReportParam || hasRoleBasedAccess(permission.CustomPowerBISetup, true);
  };

  const routerConfig = [
    {
      element: (
        <Authenticated>
          <>
            {(url?.split("siteID=")[1]?.split("&")[0] === undefined &&
              url?.split("siteID=")[1]?.split("&")[0] === null) ||
              flag === false ? (
              <Header
                appTitle={applicationTitle}
                userActionList={userActions}
                user={user as User}
                logout={logout}
              />
            ) : (
              <></>
            )}
          </>

          {flagPermision ? (
            <>
              <SharedLayout
                maxWidth={undefined}
                isNavigationBarEnabled={true}
                applicationTitle={applicationTitle}
                headerUserActionLinks={userActions}
                hqSiteId={url?.split("siteID=")[1]?.split("&")[0]}
                flag={flag}
              />
              <NexusChatLauncher />
            </>
          ) : null}
        </Authenticated>
      ),
      children: [
        {
          path: "/",
          element: (
            <Home setUserInfo={setUserInfo} flag={flag} setflag={setflag} />
          ),
        },
        // {
        //   path: "/createTask",
        //   element: permission.CreateTasks ? <CreateTask /> : <Navigate to="/" />,
        // },
        {
          path: "/powerBI-information-tracker",
          element: <PowerBIReportIM />,
          loader: () => {
            return <PowerBIReportIM />;
          },
        },
        {
          path: "/powerBI-site-information-tracker",
          element: <PowerBISiteIM />,
          loader: () => {
            return <PowerBISiteIM />;
          },
        },
        {
          path: "/powerBI-controversy-tracker",
          element: <ControversyTracker />,
          loader: () => {
            return <ControversyTracker />;
          },
        },
        {
          path: "/Planning-Ideas",
          element: <PBIPlanningIdeas />,
          loader: () => {
            return <PBIPlanningIdeas />;
          },
        },
        {
          path: "/Project-tracker-Lite",
          element: <ProjectTrackerLite />,
          loader: () => {
            return <ProjectTrackerLite />;
          },
        },
        {
          path: "/CS_GlobalDirect",
          element: <CS_GlobalDirect />,
          loader: () => {
            return <CS_GlobalDirect />;
          },
        },
        {
          path: "/CS_USDirect",
          element: <CS_USDirect />,
          loader: () => {
            return <CS_USDirect />;
          },
        },
        {
          path: "/CS_EFilingTracker",
          element: <EFilingTracker />,
          loader: () => {
            return <EFilingTracker />;
          },
        },
        {
          path: "/CS_ProjectTrackerFull",
          element: <ProjectTrackerFull />,
          loader: () => {
            return <ProjectTrackerFull />;
          },
        },
        {
          path: "/CashTaxDashboard",
          element: <CashTaxDashboard />,
          loader: () => {
            return <CashTaxDashboard />;
          },
        },
        {
          path: "/sites",
          element: hasAccess(permission.CreateSites, false) ? (
            <SitesWithLegalEntities />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <SitesWithLegalEntities />;
          }
        },
        {
          path: "/projects",
          element: hasAccess(permission.TIMProjects, true, FEATURES.TIM_PROJECTS) ? <ProjectsView /> : <AccessDenied />,
          loader: () => {
            return <ProjectsView />;
          },
        },
        {
          path: "/nexus-chat",
          element: <Navigate to="/" replace />,
        },
        {
          path: "/CreateSitesAutomate",
          element: hasAccess(permission.CreateSitesAutomate, false) ? (
            <CreateSitesAutomate />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <CreateSitesAutomate />;
          }
        },
        {
          path: "/clients",
          element: hasAccess(permission.CreateSites, false) ? <Clients /> : <Navigate to="/" />,
          loader: () => {
            return <Clients />;
          },
        },
        {
          path: "/addclients",
          element: hasAccess(permission.CreateSites, false) ? (
            <AddClients />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <AddClients />;
          },
        },
        {
          path: "/updateSites",
          element: hasAccess(permission.Assignments, false) ? (
            <UpdateSites />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <UpdateSites />;
          },
        },
        {
          path: "/siteSettingsManager",
          element: hasAccess(permission.SiteSettingsManager, false) ? (
            <SiteSettingsManager />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <SiteSettingsManager />;
          }
        },
        {
          path: "/siteNotifications",
          element: <SiteNotifications />,
          loader: () => {
            return <SiteNotifications />;
          }
        },
        {
          path: "/createFolder",
          element: hasAccess(permission.CreateFolders, false) ? (
            <CreateFolders />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <CreateFolders />;
          }
        },
        {
          path: "/siteAdminAccess",
          element: hasAccess(permission.AssignUsers, false) ? (
            <SiteAdminAccess />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <SiteAdminAccess />;
          }
        },
        {
          path: "/updateMetadataLocationFiles",
          element: hasAccess(permission.UpdateMetadataLocationFiles, false) ? (
            <UpdateMetadataLocationFiles />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <UpdateMetadataLocationFiles />;
          }
        },
        {
          path: "/upgradeSites",
          element: hasAccess(permission.UpgradeSites, false) ? (
            <UpgradeSites />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <UpgradeSites />;
          }
        },
        {
          path: "/scheduleFiles",
          element: hasAccess(permission.ScheduleFiles, false) ? (
            <ScheduleFiles />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <ScheduleFiles />;
          }
        },
        {
          path: "/thirdPartyOrganization",
          element: hasAccess(permission.ThirdpartyOrganization, false) ? (
            <ThirdpartyOrganization />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <ThirdpartyOrganization />;
          }
        },
        {
          path: "/siteMetrics",
          element: hasAccess(permission.LeaderShip, false) ? (
            <SiteMetrics />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <SiteMetrics />;
          }
        },
        {
          path: "/fsTemplates",
          element: <FSTemplates />,
          loader: () => {
            return <FSTemplates />;
          }
        },
        {
          path: "/siteProjectStatus",
          element: <SiteProjectStatus />,
          loader: () => {
            return <SiteProjectStatus />;
          }
        },
        {
          path: "/rollovers",
          element:
            hasAccess(permission.Rollovers, true, FEATURES.ROLLOVERS) ? (
              <NewRollovers />
            ) : (
              <AccessDenied />
            ),
          loader: () => {
            return hasAccess(permission.Rollovers, true, FEATURES.ROLLOVERS) ? (
              <NewRollovers />
            ) : (
              <AccessDenied />
            );
          }
        },
        {
          path: "globaltaxinformation",
          element: <GlobalTaxInformation />,
          loader: () => {
            return <GlobalTaxInformation />;
          },
        },
        {
          path: "/iManageFiles",
          element:
            hasAccess(permission.IManageFiles, true, FEATURES.I_MANAGE_FILES) ? (
              <IManageFilesContainer />
            ) : (
              <AccessDenied />
            ),
          loader: () => {
            return <IManageFilesContainer />;
          },
        },
        {
          path: "/centralControversyTracker",
          element: hasAccess(permission.CentralControversyTracker, false) ? (
            <CentralControversyTracker />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <CentralControversyTracker />;
          },
        },
        {
          path: "/bulkSiteCreation",
          element: hasAccess(permission.CreateSitesAutomate, false) ? (
            <BulkSiteCreation />
          ) : (
            <Navigate to="/" />
          ),
          loader: () => {
            return <BulkSiteCreation />;
          },
        },
        {
          path: "/userAssignments",
          element: hasAccess(permission.UserAssignmentHistory, true, FEATURES.USER_ASSIGNMENT_HISTORY) ? <UserAssignments /> : <AccessDenied />,
          loader: () => {
            return <UserAssignments />;
          }
        },
        {
          path: "/manageCustomPermissions",
          element:
            hasAccess(permission.ManageCustomPermissions, true, FEATURES.MANAGE_CUSTOM_PERMISSIONS) ? (
              <ManageCustomPermissions />
            ) : (
              <AccessDenied />
            ),
          loader: () => {
            return <ManageCustomPermissions />;
          }
        },
        {
          path: "/customPermissions",
          element:
            hasAccess(permission.CustomPermissionReport, false) ? (
              <CustomPermissions />
            ) : (
              <AccessDenied />
            ),
          loader: () => {
            return <CustomPermissions />;
          }
        },
        {
          path: "/customPowerBIReports",
          element: (isSystemAdmin || hasRoleBasedAccess(permission.CustomPowerBISetup, true)) ? (
            <CustomPowerBISiteReports />
          ) : (
            <AccessDenied />
          ),
          loader: () => {
            return <CustomPowerBISiteReports />;
          },
        },
        {
          path: "/PowerBIReport",
          element: (isSystemAdmin || (userAssignments?.length ?? 0) > 0) ? (
            <CommonPowerBIPage />
          ) : (
            <AccessDenied />
          ),
          loader: () => null,
        },
        {
          path: "/customPowerBISetup",
          element: (isSystemAdmin || canAccessCustomPowerBISetup()) ? (
            <CustomPowerBISetup />
          ) : (
            <AccessDenied />
          ),
          loader: () => {
            return <CustomPowerBISetup />;
          },
        },
      ],
    },
    {
      element: <Anonymous> </Anonymous>,
      children: [
        {
          path: "*",
          element: <PageNotFound />,
        },
      ],
    },
  ];

  const router = createBrowserRouter(routerConfig);

  return (
    <div className="home">
      {/* <iframe
      srcDoc={iframeContent}
      style={{ width: '100%', height: '500px', border: 'none' }}
    /> */}
      {window.location.href.includes("/signout") ? (
        <SignOut />
      ) : (
        <CattThemeProvider theme={Theme.BLUE}>
          <RouterProvider router={router} />
        </CattThemeProvider>
      )}

      {/* {useRecoilValue(taskTemplateSelector)} */}

    </div>
  );
};

export default App;